export const setToHighDpi = (originalSize) => String(2 * Number(originalSize));
export var ImageServiceType;
(function (ImageServiceType) {
    ImageServiceType[ImageServiceType["LIQUID_PIXELS"] = 0] = "LIQUID_PIXELS";
    ImageServiceType[ImageServiceType["AKAMAI"] = 1] = "AKAMAI";
    ImageServiceType[ImageServiceType["UNKNOWN"] = 2] = "UNKNOWN";
})(ImageServiceType || (ImageServiceType = {}));
export const cdnRegex = {
    liquidpixel: /(^http:)?\/\/lp2\.hm\.com\/hmgoep(prod|dev)/,
    akamai: /(^http:)?\/\/image\.hm\.com\/assets\/hm/,
};
//# sourceMappingURL=constants.js.map